import { Component, OnInit }    from '@angular/core';
import { Router }               from '@angular/router';
import { Observable }           from 'rxjs/Observable';

import { PuiAuthService, PuiAppSettings, PuiAppHooks, PuiDeactivateHook } from '../../../core';

@Component({
    selector: 'pui-logout',
    templateUrl: 'logout.component.html'
})
export class PuiLogoutComponent implements OnInit, PuiDeactivateHook {
    constructor(public authService: PuiAuthService,
                public router: Router,
                public hook: PuiAppHooks) { }

    ngOnInit() {
        this.logout();
    }

    logout() {
        this.authService.logout();
        const redirect = PuiAppSettings.defaultUrl;
        this.router.navigate([redirect]);
    }

    onLogout() {
        this.logout();
    }

    deactivateHook(): Observable<boolean> | Promise<boolean> | boolean {
        return this.hook.deactivateLogout();
    }
}
